// extracted by mini-css-extract-plugin
export default {"studentInfo":"MaCtFXReox0U7UBSZmbb"};